import { render, staticRenderFns } from "./term1.vue?vue&type=template&id=063959e6&scoped=true&"
import script from "./term1.vue?vue&type=script&lang=js&"
export * from "./term1.vue?vue&type=script&lang=js&"
import style0 from "./term1.vue?vue&type=style&index=0&id=063959e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063959e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCheckbox})
